import { useCMSPageField } from '@/cms/fields'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createDataLayerEvent } from '@/scopes/products/pages/components/Legacy/PracticalInformation/helpers/CreateDataLayerEvent'
import { Accordion } from '@sunwebgroup/ui-components'

export interface SurroundingsInformationProps {
  title: string
}

export function SurroundingsInformation({ title }: SurroundingsInformationProps) {
  const info = useCMSPageField('PDP.surroundings')
  const { sendEvent } = useAnalytics()

  const handleChange = (isOpen: boolean) => {
    if (isOpen) {
      sendEvent(createDataLayerEvent({ element: 'Surroundings info', isOpen: true }))
    }
    else {
      sendEvent(createDataLayerEvent({ element: 'Surroundings info', isOpen: false }))
    }
  }

  if (!info?.length)
    return null

  return (
    <Accordion.Item title={title} icon="IconMap" onOpenChange={handleChange}>
      <ul>
        {info.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </Accordion.Item>
  )
}
